<template>
  <div class="osm-autocomplete">
    <input
      :id="id"
      ref="input"
      v-model="query"
      type="text"
      class="osm-autocomplete__input"
      :placeholder="placeholder"
      autocomplete="off"
      @input="onInput"
      @focus="open = results.length > 0"
    />
    <ul v-if="open && results.length" class="osm-autocomplete__list">
      <li
        v-for="(item, index) in results"
        :key="item.place_id || index"
        @mousedown.prevent="pick(item)"
      >
        {{ item.formatted_address }}
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "OsmAutocomplete",
  props: {
    id: String,
    placeholder: String,
  },
  data() {
    return {
      query: "",
      results: [],
      open: false,
      timer: null,
    };
  },
  methods: {
    onInput() {
      this.$el.value = this.query;
      clearTimeout(this.timer);
      if (!this.query || this.query.length < 2) {
        this.results = [];
        this.open = false;
        return;
      }
      this.timer = setTimeout(() => this.search(), 350);
    },
    search() {
      axios
        .get("/maps/search", { params: { q: this.query } })
        .then((res) => {
          this.results = res.data.results || [];
          this.open = this.results.length > 0;
        })
        .catch(() => {
          this.results = [];
          this.open = false;
        });
    },
    pick(item) {
      this.query = item.formatted_address;
      this.open = false;
      this.$el.value = this.query;
      const lat = Number(item.geometry.location.lat);
      const lng = Number(item.geometry.location.lng);
      this.$emit("place_changed", {
        place_id: item.place_id,
        formatted_address: item.formatted_address,
        geometry: {
          location: {
            lat: function () {
              return lat;
            },
            lng: function () {
              return lng;
            },
          },
        },
      });
    },
    clear() {
      this.query = "";
      this.results = [];
      this.open = false;
      this.$el.value = "";
      if (this.$refs.input) this.$refs.input.value = "";
    },
    focus() {
      if (this.$refs.input) this.$refs.input.focus();
    },
    setValue(value) {
      this.query = value || "";
      this.$el.value = this.query;
    },
  },
  mounted() {
    this.$el.value = this.query;
    Object.defineProperty(this.$el, "value", {
      configurable: true,
      get: () => this.query,
      set: (v) => {
        this.query = v || "";
      },
    });
  },
};
</script>

<style scoped>
.osm-autocomplete {
  position: relative;
  width: 100%;
}
.osm-autocomplete__input {
  width: 100%;
  border: 0;
  outline: none;
  font: inherit;
  background: transparent;
}
.osm-autocomplete__list {
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e0e0e0;
  max-height: 240px;
  overflow: auto;
}
.osm-autocomplete__list li {
  padding: 8px 12px;
  cursor: pointer;
}
.osm-autocomplete__list li:hover {
  background: #f5f5f5;
}
</style>
